import React, { forwardRef } from 'react';
import './footer.css';
import politicaTratamiento from "../assets/POLITICA-DE-TRATAMIENTO-DE-DATOS.docx";

const Footer = forwardRef((props, ref) => {
  return (
    <footer ref={ref} className="green-header enhanced-footer">
      <div className="footer-content">
        <div className="footer-brand">
          <img
            src={require("../assets/defensa3.webp") || "/placeholder.svg"}
            alt="Logo"
            className="footer-logo"
          />
          <p className="policy-container">
            <a
              href={politicaTratamiento}
              target="_blank"
              rel="noopener noreferrer"
              className="policy-btn"
            >
              <i className="fas fa-file-contract"></i> Consultar políticas
            </a>
          </p>
        </div>

        <div className="footer-map">
          <h3 style={{ fontSize: 25 }}>Nuestra ubicación</h3>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3974.2766932743293!2d-75.48934172505774!3d5.058833538448908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e47657dd82e0f35%3A0x683cfe845b066589!2sCapitalia%20Centro%20Empresarial!5e0!3m2!1ses-419!2sco!4v1760568672684!5m2!1ses-419!2sco"
              width="100%"
              height="200"
              style={{ border: 0, borderRadius: "8px" }}
              allowFullScreen=""
              loading="lazy"
              title="Mapa Manizales"
            ></iframe>
            <p className="map-address">
              <i className="fas fa-map-marker-alt"></i> Manizales
              <br />
              <i className="fas fa-phone"></i> Tel: +57 3102646177
              <br />
              <i className="fas fa-map-marker-alt"></i> Carrera 23 # 62-39 Edificio Capitalia oficina 602a, Manizales.
            </p>
          </div>
        </div>
      </div>

      <div className="copyright">
        <p>
          © {new Date().getFullYear()} Asesorias. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>
  );
});

Footer.displayName = 'Footer';

export default Footer;